import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Label } from '../Typography';

interface RadioProps {
  label?: string;
  name: string;
  checked?: boolean;
  onChange?: () => void;
  className?: string;
}

const Layout = styled.div`
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  height: auto;
`;

const SIZE = 16;

const StyledLabel = styled(Label)`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  cursor: pointer;
  gap: ${toRem(theme.space.md)};

  > span {
    display: flex;
    width: ${toRem(SIZE)};
    height: ${toRem(SIZE)};
    border-radius: 50%;
    border: ${toRem(1.25)} solid ${theme.color.neutral[200]};
    background-color: ${theme.color.white};
  }

  &:hover {
    > span {
      background-color: ${theme.color.white};
    }
  }
`;

const Input = styled.input.attrs({
  type: 'radio',
})`
  appearance: none;
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    & ~ span {
      border-color: ${theme.color.secondary[400]};
    }
  }

  &:checked {
    & ~ span {
      border-color: ${theme.color.secondary[400]};
      border-width: ${toRem(4)};
    }
  }
`;

const Radio: React.FC<RadioProps> = ({ label, name, checked, onChange, className }) => (
  <Layout className={className}>
    <StyledLabel>
      <Input name={name} checked={checked} onChange={onChange} />
      <span />
      {label}
    </StyledLabel>
  </Layout>
);

export default Radio;
